import { apiRequest } from './client'
import type { ChangePasswordRequest, LoginResponse, User } from '@/types'

export async function login(username: string, password: string): Promise<LoginResponse> {
  return apiRequest<LoginResponse>('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username: username.trim().toLowerCase(), password }),
  })
}

export async function me(): Promise<User> {
  return apiRequest<User>('/api/auth/me')
}

export function logout(): void {
  localStorage.removeItem('auth_token')
}

export async function changePassword(body: ChangePasswordRequest): Promise<void> {
  return apiRequest<void>('/api/auth/change-password', {
    method: 'POST',
    body: JSON.stringify(body),
  })
}

export async function logoutAll(): Promise<void> {
  return apiRequest<void>('/api/auth/logout-all', { method: 'POST' })
}
